<template lang="pug">

table.ui.table(v-show='companyModels.length > 0')
    thead
        tr
            th.five.wide Name
            th.three.wide Typ
            th.three.wide Ort
            th.three.wide

    tbody
        tr(
            is='row'
            v-for='companyModel in companyModels'
            v-bind:key='companyModel.id'
            v-bind:address-models='addressModels'
            v-bind:company-model='companyModel'
        )

</template>

<script>
    import Row from './table/Row.vue'

    export default {

        components: { Row },

        props: {

            addressModels: {
                type: Array,
                required: true
            },

            companyModels: {
                type: Array,
                required: true
            }

        }
    }

</script>
